module.exports = __webpack_public_path__ + "static/media/DA.2b57e84a.svg";